import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const addInternetPlanFocused: IMcAppType = {
  name: "addInternetPlanFocused",
  path: "/my/add-internet-plan",
  description:
    "This is the landing page for authenticated adding Internet plan",
  navFlow: NavFlow.FOCUS,
  title: "Add Internet",
  parent: Tab.MORE,
  conditions: {
    intent: "addInternetPlanFocused",
    customerType: CustomerType.kraken,
  },
};
